"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "barberino-tavarnelle": {
    "9b3df33d": [{
      "hkey": "d607dd6b",
      "slug": "tavarnelle-val-di-pesa",
      "name": "Tavarnelle Val di Pesa",
      "primary": true,
      "skipSearch": false
    }],
    "tavarnelle": [{
      "hkey": "d607dd6b",
      "slug": "tavarnelle-val-di-pesa",
      "name": "Tavarnelle Val di Pesa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c3a3978a": [{
      "hkey": "77ddb6b2",
      "slug": "noce-palazzuolo",
      "name": "Noce-Palazzuolo",
      "primary": true,
      "skipSearch": false
    }],
    "noce": [{
      "hkey": "77ddb6b2",
      "slug": "noce-palazzuolo",
      "name": "Noce-Palazzuolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "74d00785": [{
      "hkey": "0c9a8578",
      "slug": "badia-a-passignano",
      "name": "Badia a Passignano",
      "primary": true,
      "skipSearch": false
    }],
    "passignano": [{
      "hkey": "0c9a8578",
      "slug": "badia-a-passignano",
      "name": "Badia a Passignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;